import { produce } from 'immer';

import { getCharts, getChartsPeriods, cleanChartsList } from '../actions/charts';

const initialState = {
  data: [],
  periods: [],
  loadings: {
    periods: false,
    charts: false,
  },
};

const reducer = produce((state = initialState, action) => {
  switch (action.type) {
    // GET CHARTS
    case getCharts.types.START:
      state.loadings.charts = true;
      return state;

    case getCharts.types.SUCCESS:
      state.loadings.charts = false;
      state.data = action.payload.data;
      return state;

    case getCharts.types.FAIL:
      state.loadings.charts = false;
      return state;

    // GET PERIODS
    case getChartsPeriods.types.START:
      state.periods = [];
      state.loadings.periods = true;
      return state;

    case getChartsPeriods.types.SUCCESS:
      state.periods = action.payload.periods;
      state.loadings.periods = false;
      return state;

    case getChartsPeriods.types.FAIL:
      state.loadings.periods = false;
      return state;

    // CLEAN CHARTS
    case cleanChartsList.types.INIT:
      state.loadings.data = initialState.data;
      state.loadings.periods = initialState.periods;
      return state;

    default:
      return state;
  }
});

export default reducer;
